module.exports = __webpack_public_path__ + "static/media/logo-benchmark.8fd29176.svg";